import {FC} from 'react';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Box from '@mui/material/Box';
import TableHeadContactPerson from '../AddCompany/AddCompanyForm/ContactPersonForm/TableHeadContactPerson/TableHeadContactPerson';
import ShowContactPersons from './ShowContactPersons';

import {IContactPerson} from '../../../../shared/types/person.types';
import {IHeadCellContactPerson} from '../../../../shared/types/table.types';

interface IShowContactPersonsContainer {
  contactPersons: IContactPerson[];
}

const headCells: IHeadCellContactPerson[] = [
  {
    disablePadding: false,
    id: 'fullPersonName',
    label: 'ФИО',
  },
  {
    disablePadding: false,
    id: 'phoneNumber',
    label: 'Номер телефона',
  },
  {
    disablePadding: false,
    id: 'email',
    label: 'Email',
  },
  {
    disablePadding: false,
    id: 'birthDate',
    label: 'Дата рождения',
  },
];

const ShowContactPersonsContainer: FC<IShowContactPersonsContainer> = ({contactPersons}) => {
  return (
    <Box sx={{width: '100%'}}>
      <TableContainer>
        <Table>
          <TableHeadContactPerson headCells={headCells} collapse />
          <ShowContactPersons contactPersons={contactPersons} />
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ShowContactPersonsContainer;
